import axios from "axios";
import { format } from "date-fns";

export const getTotalByMonth = async (chartName, yyyymm, storeId, filters) => {
  let params = {
    name: chartName,
    store_id: storeId,
    m: yyyymm,
    ...filters,
  };
  const response = await axios.get(`/charts/`, {
    params,
  });

  return response.data;
};

export const getDataByStartAndEndDate = async (chartName, startDate, endDate, storeId, filters) => {
  const targetStartDate = format(startDate, "yMMdd");
  const targetEndDate = format(endDate, "yMMdd");
  let params = {
    name: chartName,
    store_id: storeId,
    from: targetStartDate,
    to: targetEndDate,
    ...filters,
  };
  const response = await axios.get(`/charts/`, {
    params,
  });

  return response.data;
};
